import React from "react";
import {
    Datagrid,
    DateField,
    Filter,
    ImageField,
    ImageInput,
    List,
    ReferenceField,
    SelectInput,
    SimpleShowLayout,
    TextField,
    ReferenceInput,
    TextInput,
    required,
    BooleanInput,
    BooleanField,
    NumberField,
    NumberInput,
    maxLength,
    ArrayInput,
    SimpleFormIterator, ArrayField,
} from "react-admin";
import { ColorField, ColorInput } from 'react-admin-color-input';
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";
import {GradientColorInputTags} from "./forumConstant";
import {Markets} from "../../constants/choices";

const ForumFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="دسته فروم" source="forumCategoryId" reference="forumCategory">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <BooleanInput source="adsActive"/>
    <BooleanInput source="isAdPublic"/>
    <BooleanInput source="isPremium"/>
    <BooleanInput source="isDisabled"/>
    <TextInput source="title"/>
    <NumberInput source="ageLimit"/>
  </Filter>
);

export const ForumList = (props) => (
  <List {...props} filters={<ForumFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <ImageField source="icon"/>
      <TextField source="title"/>
        <TextField source="description"/>
        <ReferenceField  label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
      <BooleanField source="isPremium"/>
      <BooleanField source="isDisabled"/>
        <ReferenceField link="show" label="دسته فروم" source="forumCategoryId" reference="forumCategory" >
        <TextField source="title"/>
      </ReferenceField>
        <BooleanField source="adsActive"/>
    </Datagrid>
  </List>
);

export const ForumEdit = (props) => (
  <EditView {...props}>
    <ReferenceInput label="دسته فروم" validate={required()} source="forumCategoryId" reference="forumCategory">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <TextInput source="title" validate={required()}/>
    <Emoji source="description" label="توضیحات" validate={required()} />
    <BooleanInput source="isPremium" validate={required()}/>
    <BooleanInput source="isDisabled" validate={required()}/>
    <ImageInput source="pictures"  label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" title="title"/>
    </ImageInput>
    <TextInput source="icon" validate={required()}/>
      <BooleanInput source="adsActive" defaultValue={false} />
      <TextInput source="adsButtonTitle" validate={maxLength(8)}/>
      <TextInput source="adsTitle" validate={maxLength(24)}/>
      <ColorInput source="adsSolidColor"/>
      <b>جهت گرادیدانت ها از راست به چپ است.</b>
      <SelectInput source="adsGradiantColor" choices={GradientColorInputTags} />
      <NumberInput source="adsVersion"/>
      <TextInput source="link"/>
      <NumberInput source="ageLimit"/>
      <BooleanInput source="isAdPublic"/>
      <ArrayInput source="adminMarkets">
          <SimpleFormIterator>
              <SelectInput source="markets" choices={Markets} />
          </SimpleFormIterator>
      </ArrayInput>
  </EditView>
);

export const ForumShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <ImageField source="icon"/>
      <TextField source="objectId"/>
      <TextField source="title"/>
      <TextField source="description"/>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
      <TextField source="deepLink"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <BooleanField source="isPremium"/>
      <NumberField source="userCount"/>
      <NumberField source="specialistUserCount"/>
      <NumberField source="messageCount"/>
      <NumberField source="specialistMessageCount"/>
      <NumberField source="voiceCount"/>
      <NumberField source="imageCount"/>
      <NumberField source="replyCount"/>
      <NumberField source="usersWithAtLeastOneMessageCount"/>
      <BooleanField source="isDisabled"/>
      <ReferenceField link="show" label="دسته فروم" source="forumCategoryId" reference="forumCategory" >
        <TextField source="title"/>
      </ReferenceField>
        <BooleanField source="adsActive"/>
        <TextField source="adsButtonTitle"/>
        <TextField source="adsTitle"/>
        <ColorField source="adsSolidColor"/>
        <b>جهت گرادیدانت ها از راست به چپ است.</b>
        <TextField source="adsGradiantColorShow" />
        <NumberField source="adsVersion"/>
        <TextField source="link"/>
        <BooleanField source="isAdPublic"/>
        <NumberField source="ageLimit"/>
        <ArrayField source="adminMarkets">
            <Datagrid>
                <TextField source="markets" />
            </Datagrid>
        </ArrayField>
    </SimpleShowLayout>
  </ShowView>
);

export const ForumCreate = (props) => (
  <CreateView {...props}>
    <ReferenceInput label="دسته فروم" source="forumCategoryId" validate={required()} reference="forumCategory">
      <SelectInput optionText="title"  alwaysOn/>
    </ReferenceInput>
    <TextInput source="title" validate={required()}/>
    <BooleanInput source="isPremium" defaultValue={false} />
    <BooleanInput source="isDisabled" defaultValue={false} />
      <Emoji source="description" label="توضیحات" validate={required()} />
    <ImageInput source="pictures" validate={required()} label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" validate={required()} title="title"/>
    </ImageInput>
    <BooleanInput source="adsActive" defaultValue={false} />
      <TextInput source="adsButtonTitle" validate={maxLength(8)}/>
      <TextInput source="adsTitle" validate={maxLength(24)}/>
    <ColorInput source="adsSolidColor"/>
    <b>جهت گرادیدانت ها از راست به چپ است.</b>
    <SelectInput source="adsGradiantColor" choices={GradientColorInputTags} />
    <NumberInput source="adsVersion"/>
    <TextInput source="link"/>
    <NumberInput source="ageLimit"/>
    <BooleanInput source="isAdPublic"/>
      <ArrayInput source="adminMarkets">
          <SimpleFormIterator>
              <SelectInput source="markets" choices={Markets} />
          </SimpleFormIterator>
      </ArrayInput>
  </CreateView>
);